var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLinkAccount1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 20C5 14.4772 9.47715 10 15 10H45C50.5228 10 55 14.4772 55 20V25C55 26.3807 53.8807 27.5 52.5 27.5C51.1193 27.5 50 26.3807 50 25V20C50 17.2386 47.7614 15 45 15H15C12.2386 15 10 17.2386 10 20V40C10 42.7614 12.2386 45 15 45H30C31.3807 45 32.5 46.1193 32.5 47.5C32.5 48.8807 31.3807 50 30 50H15C9.47715 50 5 45.5228 5 40V20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5479 20.9384C16.4104 19.8602 17.9837 19.6854 19.0618 20.5479L30.0001 29.2985L40.9384 20.5479C42.0165 19.6854 43.5897 19.8602 44.4523 20.9384C45.3148 22.0165 45.14 23.5897 44.0618 24.4523L30.0001 35.7017L15.9384 24.4523C14.8602 23.5897 14.6854 22.0165 15.5479 20.9384Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7099 35.6762C57.7172 36.6205 57.7683 38.2026 56.8239 39.2099L47.4489 49.2099C46.5533 50.1652 45.0723 50.2675 44.0538 49.4445L38.4288 44.899C37.3549 44.0312 37.1878 42.4572 38.0556 41.3833C38.9234 40.3093 40.4975 40.1423 41.5714 41.0101L45.3898 44.0957L53.1762 35.7902C54.1206 34.7829 55.7027 34.7318 56.7099 35.6762Z",
    fill: "#01E99F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLinkAccount1);
export default __webpack_public_path__ + "static/media/new-link-account-1.024442d27c37d6c446e705861fc5c19b.svg";
export { ForwardRef as ReactComponent };